function viewAll() {
  $('.plug-view-all-button').click(function(){
    var section = $(this).data('section-id');
    if($(this).text() == 'View All') {
      $('.plug-view-all[data-section-id=' + section + ']').css('display', 'block');
      $('.plug-product-slider__wrapper[data-section-id=' + section + ']').css('display', 'none');
      $(this).text('View Less');
    } else if ($(this).text() == 'View Less'){
      $('.plug-view-all[data-section-id=' + section + ']').css('display', 'none');
      $('.plug-product-slider__wrapper[data-section-id=' + section + ']').css('display', 'block');
      $(this).text('View All');
    }
    window.dispatchEvent(new Event('resize'));
  });
}

$(document).ready(function(){
  viewAll();
  $(document)
  .on('shopify:section:load', function(){viewAll();})
  .on('shopify:section:unload', function(){viewAll();})
  .on('shopify:section:select', function(){viewAll();})
  .on('shopify:section:deselect', function(){viewAll();})
  .on('shopify:section:reorder', function(){viewAll();})
  .on('shopify:block:select', function(){viewAll();})
  .on('shopify:block:deselect', function(){viewAll();});
});
